var React = require('react');

function EmailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.495 5 12 12.655 20.505 5H3.495zM2 17.586l5.916-5.916L2 6.345v11.24zm7.405-4.576L3.415 19h17.17l-5.99-5.99L12 15.345 9.405 13.01zM22 6.345v11.24l-5.916-5.915L22 6.345zM0 6a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6z","fill":"#fff"}));
}

EmailIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EmailIcon;

EmailIcon.default = EmailIcon;
